import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Box,IconButton,Grid, useMediaQuery } from '@mui/material';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTheme } from '@emotion/react';
import RoomBooking from './RoomBooking';
import dayjs from 'dayjs';
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
export default function FromDateComponent() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const today = dayjs();
  const [selectedDate, setSelectedDate] = React.useState("");
  const [currentDate, setCurrentDate] = React.useState(today);

  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const theme = useTheme();

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const daysOfWeek = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

  const daysInMonth = currentDate.daysInMonth();
  const firstDayOfMonth = (currentDate.startOf("month").day() + 6) % 7;

  const isPastDay = (day) => currentDate.date(day).isBefore(today, "day");

  const selectedDay =
    selectedDate.trim() !== "" ? dayjs(selectedDate, "DD-MM-YYYY") : null;

  const isSelected = (day) =>
    selectedDay && currentDate.date(day).isSame(selectedDay, "day");

  const handlePrevMonth = () => {
    if (currentDate.isAfter(today.startOf("month"))) {
      setCurrentDate(currentDate.subtract(1, "month"));
    }
  };

  const handleNextMonth = () => setCurrentDate(currentDate.add(1, "month"));

  const handleDateSelect = (day) => {
    if (!isPastDay(day)) {
      const chosen = currentDate.date(day).format("DD-MM-YYYY");
      setSelectedDate(chosen);
      handleClose();
    }
  };

  return (
    <div>
      {/* Trigger Box */}
      <Box
        aria-describedby={id}
        onClick={handleClick}
        sx={{
          width: isSmallScreen ? "100%" : "220px",
          p: 1.5,
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #D6DAC8",
          transition: "0.2s",
          "&:hover": {
            boxShadow: "0px 3px 10px rgba(0,0,0,0.1)",
          },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "11px",
              color: "#6B7280",
              fontWeight: 500,
            }}
          >
            FROM DATE
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <CalendarMonthIcon sx={{ color: "#374151" }} />
            <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
              {selectedDate || "Select Date"}
            </Typography>
          </Box>
        </Box>

        <KeyboardArrowDownIcon sx={{ fontSize: "1.7rem", color: "#374151" }} />
      </Box>

      {/* Calendar Popover */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            borderRadius: "14px",
            boxShadow: "0px 6px 18px rgba(0,0,0,0.15)",
            overflow: "hidden",
          },
        }}
      >
        <Box sx={{ width: isSmallScreen ? 310 : 400, p: 2 }}>
          {/* Month Navigation */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <IconButton
              onClick={handlePrevMonth}
              disabled={currentDate.isSame(today, "month")}
              sx={{
                color: "#555",
                "&:hover": { backgroundColor: "#F3F4F6" },
                "&.Mui-disabled": { opacity: 0.3 },
              }}
            >
              <ArrowBack />
            </IconButton>

            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.3rem",
              }}
            >
              {currentDate.format("MMMM YYYY")}
            </Typography>

            <IconButton
              onClick={handleNextMonth}
              sx={{
                color: "#555",
                "&:hover": { backgroundColor: "#F3F4F6" },
              }}
            >
              <ArrowForward />
            </IconButton>
          </Box>

          {/* Days Row */}
          <Grid container spacing={1} sx={{ mt: 1 }}>
            {daysOfWeek.map((day) => (
              <Grid item xs={1.71} key={day}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "0.9rem",
                    color: "#6B7280",
                  }}
                >
                  {day}
                </Typography>
              </Grid>
            ))}
          </Grid>

          {/* Dates Grid */}
          <Grid container spacing={1} sx={{ mt: 1 }}>
            {/* Blank spaces before first day */}
            {[...Array(firstDayOfMonth)].map((_, i) => (
              <Grid item xs={1.71} key={i} />
            ))}

            {/* Dates */}
            {[...Array(daysInMonth)].map((_, dayIndex) => {
              const day = dayIndex + 1;
              const past = isPastDay(day);
              const selected = isSelected(day);

              return (
                <Grid item xs={1.71} key={dayIndex}>
                  <Box
                    onClick={() => handleDateSelect(day)}
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: past ? "not-allowed" : "pointer",
                      backgroundColor: selected
                        ? "#FCB53B"
                        : past
                        ? "#F3F4F6"
                        : "#fff",
                      color: selected
                        ? "#000"
                        : past
                        ? "#9CA3AF"
                        : "#111827",
                      fontWeight: selected ? 700 : 500,
                      border: selected
                        ? "2px solid #F59E0B"
                        : "1px solid #E5E7EB",
                      transition: "0.2s ease",
                      "&:hover": !past && {
                        backgroundColor: "#F3F4F6",
                      },
                    }}
                  >
                    {day}
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Popover>
    </div>
  );
}


